document.addEventListener('DOMContentLoaded', () => {
  const products_on_page = document.querySelector('.product-ul-grid');
  const nextUrl = document.getElementById('paginateNext');
  if (!nextUrl) return;
  let next_url = nextUrl.dataset.nextUrl;

  const load_more_btn = document.getElementsByClassName('load-more_btn')[0];
  const load_more_spinner = document.getElementsByClassName('load-more_spinner')[0];
  const load_spinner = document.querySelector('.load-more_spinner .loading__spinner');

  async function getNextPage() {
    try {
      let res = await fetch(next_url);
      return await res.text();
    } catch (error) {
      console.log(error);
    }
  }

  async function loadMoreProducts() {
    load_more_btn.style.display = 'none';
    load_more_spinner.style.display = 'block';
    load_spinner.classList.remove('hidden');

    let nextPage = await getNextPage();

    const parser = new DOMParser();
    const nextPageDoc = parser.parseFromString(nextPage, 'text/html');

    load_more_spinner.style.display = 'none';

    const productgrid = nextPageDoc.getElementById('product-grid');
    const new_products = productgrid.querySelectorAll('.grid__item');

    let nextPageButton = nextPageDoc.getElementById('paginateNext');
    let prevUrl = next_url;
    next_url = nextPageButton.dataset.nextUrl;

    if (next_url && prevUrl !== next_url) {
      load_more_btn.style.display = 'flex';
    }

    for (let i = 0; i < new_products.length; i++) {
      products_on_page.appendChild(new_products[i]);
    }
  }

  if (load_more_btn) {
    load_more_btn.addEventListener('click', loadMoreProducts);
  }
});
